module.exports = __webpack_public_path__ + "static/media/pdf-user.c04d2905.png";